export default {
	tasks: {
		createTask: 'Create Task',
		taskType: 'Task type',
		requireIntervention: 'Immediate action required',
		dueNextWeek: 'Due in the next 7 days',
		scheduledFuture: 'Scheduled for the future',
	},
}
